import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appRowspan]',
  standalone: true,
})
export class RowspanDirective {
  @Input() public set appRowspan(rowspan: number) {
    this.updateRowspan(rowspan);
  }

  private rowspan: number;

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  private updateRowspan(rowspan: number): void {
    if (this.rowspan === rowspan) {
      return;
    }

    this.rowspan = rowspan;

    if (typeof this.rowspan === 'number' && !Number.isNaN(this.rowspan)) {
      this.element.nativeElement.setAttribute('rowspan', this.rowspan.toFixed(0));
    } else {
      this.element.nativeElement.removeAttribute('rowspan');
    }
  }
}

